import { render } from "./HeroiconsSolidSortDescending.vue?vue&type=template&id=27e72d73"
const script = {}

import exportComponent from "/home/omid_es327/Projects/mohovers/dev/dev-laravel/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"HeroiconsSolidSortDescending.vue"]])

export default __exports__